import React, { useState, useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css';
import SignaturePad from 'react-signature-canvas'
import './sigCanvas.css'
import { useDispatch } from 'react-redux';
import { PostDDJJ } from '../../../actions';
import SweetAlert from 'sweetalert2';


const DeclaracionJurada = () => {

  
  const dispatch=useDispatch()
  const signatureCanva = useRef({})
  const [ imageURL, setImageURL ] = useState(null)
  const token = localStorage.getItem('token')

  


  const limpiar = () => signatureCanva.current.clear() 
  const guardar = () => {
    const firmaGuardada = signatureCanva.current.getTrimmedCanvas().toDataURL("image/png");
    setImageURL(firmaGuardada);
    setInput(prevInput => ({...prevInput, firma: firmaGuardada}));
  }

  

  const [selected, setSelected] = useState(new Date());
  const [selectedTutor, setSelectedTutor] = useState(new Date());

  const [input, setInput] = useState({
    nombre:'',
    apellido:'',
    tipoDeDocumento: 'dni',
    dni: '',
    domicilio: '',
    provincia: '',
    localidad: '',
    fechaDeNacimiento: '',
    telefonoParticular: '',
    telefonoCelular: '',
    email: '',
    obraSocial: '',
    fechaDelDia: '',
    firma: imageURL
  })

  const [inputTutor, setInputTutor] = useState({
    name:'',
    lastName:'',
    documentType: 'dni',
    document: '',
    adress: '',
    location: '',
    birthday: '',
    state: '',
    CP: '',
    vinculo: '',
    particularPhone: '',
    celphone: '',
    mail: '',
    medicalSecurity: ''
  })

  
  const handleChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value
    })
    
  }
  

const handleChangeTutor = (e) => {
  setInputTutor({
    ...inputTutor,
    [e.target.name]: e.target.value
})
}

const handleDateChange = (date) => {
  if (date) {
    setSelected(date);
    setInput({
      ...input,
      fechaDeNacimiento: date.toISOString().substr(0, 10)
    });
  }
};

const handleDateChangeTutor = (date) => {
  if (date) {
    setSelectedTutor(date);
    setInputTutor({
      ...inputTutor,
      fechaDeNacimiento: date.toISOString().substr(0, 10)
    });
  }
};

const handleSubmit = (e) => {
  e.preventDefault();
  dispatch(PostDDJJ(input, inputTutor, token));

  
  // Muestra la alerta con SweetAlert
  SweetAlert.fire({
    title: '¡Éxito!',
    text: 'Se cargó correctamente',
    icon: 'success',
    confirmButtonText: 'Aceptar',
  });

  setTimeout(()=> {
    // Agrega el redirect a '/formularios' usando la función 'window.location.replace'
    window.location.replace('/formularios');
  }, 1000)
}


const [errors, setErrors] = useState({});
 
  
const validate = (input) => {
  let errors = {};

  // Validar los campos requeridos
  if (!input.nombre) {
    errors.nombre = 'El nombre es requerido';
  }

  if (!input.apellido) {
    errors.apellido = 'El apellido es requerido';
  }

  if (!input.tipoDeDocumento) {
    errors.tipoDeDocumento = 'El tipo de documento es requerido';
  }

  if (!input.dni) {
    errors.dni = 'El número de documento es requerido';
  }

  if (!input.domicilio) {
    errors.domicilio = 'El domicilio es requerido';
  }

  if (!input.localidad) {
    errors.localidad = 'La localidad es requerida';
  }

  if (!input.telefonoParticular) {
    errors.telefonoParticular = 'El teléfono particular es requerido';
  }

  if (!input.telefonoCelular) {
    errors.telefonoCelular = 'El teléfono celular es requerido';
  }

  if (!input.email) {
    errors.email = 'El correo electrónico es requerido';
  }

  if (!input.obraSocial) {
    errors.obraSocial = 'La obra social es requerida';
  }
  if (!input.provincia) {
    errors.provincia = 'La provincia es requerida';
  }

  if(imageURL == null) {
    errors.firma ='Firma faltante'
  }

  if(!input.fechaDeNacimiento){
    errors.fecha = 'Elegi una fecha valida'
  }

  if(!input.fechaDelDia){
    errors.fechaDelDia = 'Elegi una fecha valida'
  }
  
  return errors;
}

useEffect(() => {
  setErrors(validate(input));
}, [input]);


  return (
    <div className='flex flex-row gap-10 items-center justify-center p-12'>
      <form className='p-12 border flex flex-col gap-5 rounded-xl shadow-xl'
      onSubmit={handleSubmit}
      >

        <h1 className='text-xl font-bold '>Datos de la persona que requiere la inscripción al registro</h1>

        <div className='flex flex-col gap-2'>
          <span className='text-slate-400 '>Nombre: </span>
          <input type="text" placeholder="Nombre" className='border p-2 rounded' value= {input.nombre} name='nombre' onChange={handleChange} />
          {errors.nombre && (<p className='text-[10px] text-red-500'>{errors.nombre}</p>)}
        </div>

        <div className='flex flex-col gap-2'>
          <span className='text-slate-400 '>Apellido: </span>
          <input type="text" placeholder="Apellido" className='border p-2 rounded' value={input.apellido} name='apellido' onChange={handleChange} />
          {errors.apellido && (<p className='text-[10px] text-red-500'>{errors.apellido}</p>)}
        </div>

        <div className='flex flex-col gap-2'>
          <span className='text-slate-400 '>Tipo de documento:</span>
          <select className='border p-2 rounded' name='tipoDeDocumento' onChange={handleChange} >
            <option value="all" disabled>Selecciona</option>
            <option value="dni">DNI</option>
            <option value="pasaporte">Pasaporte</option>
          </select>
          {errors.tipoDeDocumento && (
  <p className='text-[10px] text-red-500'>{errors.tipoDeDocumento}</p>
)}
        </div>

        <div className='flex flex-col gap-2'>
             <span className='text-slate-400 '>N° de Documento</span>
             <input type="text" placeholder='N° de Documento' value={input.dni} name='dni' className='border p-2 rounded' onChange={handleChange} /> 
             {errors.dni && (<p className='text-[10px] text-red-500'>{errors.dni}</p>)}
        </div>

        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Provincia:</span>
            <input type="text" placeholder='Provincia' value={input.provincia} name='provincia' className='border p-2 rounded' onChange={handleChange} />
            {errors.provincia && (<p className='text-[10px] text-red-500'>{errors.provincia}</p>)}
        </div>
        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Domicilio constituido:</span>
            <input type="text" placeholder='Domicilio' value={input.domicilio} name='domicilio' className='border p-2 rounded' onChange={handleChange} />
            {errors.domicilio && (<p className='text-[10px] text-red-500'>{errors.domicilio}</p>)}
        </div>

        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Localidad:</span>
            <input type="text" placeholder='Localidad' value={input.localidad} name='localidad' className='border p-2 rounded' onChange={handleChange} />
            {errors.localidad && (
  <p className='text-[10px] text-red-500'>{errors.localidad}</p>
)}
        </div>

        <div className='flex flex-col gap-2'>
          <span className='text-slate-400'>Fecha de nacimiento:</span>
            <div className='border w-full p-2 rounded'>
              <DatePicker selected={selected} onChange={handleDateChange} />  
            </div>
            {errors.fecha && (
  <p className='text-[10px] text-red-500'>{errors.fecha}</p>)}
        </div>



        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Teléfono particular:</span>
            <input type="text" placeholder='Fijo' value={input.telefonoParticular} name='telefonoParticular' className='border p-2 rounded' onChange={handleChange} />
            {errors.telefonoParticular && (
  <p className='text-[10px] text-red-500'>{errors.telefonoParticular}</p>
)}
        </div>

        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Teléfono celular:</span>
            <input type="text" placeholder='Celular' value={input.telefonoCelular} name='telefonoCelular' className='border p-2 rounded' onChange={handleChange} />
            {errors.telefonoCelular && (
  <p className='text-[10px] text-red-500'>{errors.telefonoCelular}</p>
)}
        </div>

        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Mail:</span>
            <input type="email" placeholder='Email' value={input.email} name='email' className='border p-2 rounded' onChange={handleChange} />
            <p className='text-[10px] text-red-500'>{errors.email}</p>
        </div>

        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Obra Social:</span>
            <input type="text" placeholder='Obra Social' value={input.obraSocial} name='obraSocial' className='border p-2 rounded' onChange={handleChange} />
            {errors.obraSocial && (<p className='text-[10px] text-red-500'>{errors.obraSocial}</p>)}
        </div>

        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Fecha del día:</span>
            <input type="date" placeholder='Fecha del día' value={input.fechaDelDia} name='fechaDelDia' className='border p-2 rounded' onChange={handleChange} />
            {errors.fechaDelDia && (<p className='text-[10px] text-red-500'>{errors.fechaDelDia}</p>)}
        </div>

        {/* DATOS DEL PADRE MADRE O TUTOR */}
       <div className='flex flex-col gap-2'>
        <h1 className='text-xl font-bold '>Datos del Padre / Madre / Tutor/a o Encargado/a</h1>
        <h4>(Llenar estos campos en caso de necesitar ser autorizado por un mayor)</h4>
       </div>

        <div className='flex flex-col gap-2'>
          <span className='text-slate-400 '>Nombre: </span>
          <input type="text" placeholder="Nombre" className='border p-2 rounded' value={inputTutor.name} name='name' onChange={handleChangeTutor} />
        </div>

        <div className='flex flex-col gap-2'>
          <span className='text-slate-400 '>Apellido: </span>
          <input type="text" placeholder="Apellido" className='border p-2 rounded' value={inputTutor.lastName} name='lastName' onChange={handleChangeTutor} />
        </div>
        
        <div className='flex flex-col gap-2'>
          <span className='text-slate-400 '>Tipo de documento:</span>
          <select className='border p-2 rounded' value={inputTutor.documentType} name='documentType' onChange={handleChangeTutor}>
            <option value="all" disabled>
              Selecciona
            </option>
            <option value="dni">DNI</option>
            <option value="pasaporte">Pasaporte</option>
          </select>
        </div>

        <div className='flex flex-col gap-2'>
             <span className='text-slate-400 '>N° de Documento</span>
             <input type="text" placeholder='N° de Documento' value={inputTutor.document} name='document' className='border p-2 rounded' onChange={handleChangeTutor} /> 
        </div>
        
        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Domicilio de Cultivo:</span>
            <input type="text" placeholder='Domicilio' className='border p-2 rounded' value={inputTutor.adress} name='adress' onChange={handleChangeTutor} />
        </div>
        
        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Localidad:</span>
            <input type="text" placeholder='Localidad' className='border p-2 rounded' value={inputTutor.location} name='location' onChange={handleChangeTutor} />
        </div>
        
        <div className='flex flex-col gap-2'>
          <span className='text-slate-400 '>Fecha de nacimiento:</span>
          <DatePicker selected={selectedTutor} onChange={handleDateChangeTutor} className='border w-full p-2 rounded' />
        </div>
        
        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Teléfono particular:</span>
            <input type="text" placeholder='Fijo' className='border p-2 rounded' value={inputTutor.particularPhone} name='particularPhone' onChange={handleChangeTutor} />
        </div>
        
        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Teléfono celular:</span>
            <input type="text" placeholder='Celular' className='border p-2 rounded' value={inputTutor.celphone} name='celphone' onChange={handleChangeTutor} />
        </div>

        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Provincia:</span>
            <input type="text" placeholder='Provincia' className='border p-2 rounded' value={inputTutor.state} name='state' onChange={handleChangeTutor} />
        </div>

        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>CP:</span>
            <input type="text" placeholder='CP' className='border p-2 rounded' value={inputTutor.CP} name='CP' onChange={handleChangeTutor} />
        </div>
        
        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Vinculo con la persona que requiere la inscripcción:</span>
            <input type="text" placeholder='Vinculo con la persona que requiere la inscripcción' className='border p-2 rounded' value={inputTutor.vinculo} name='vinculo' onChange={handleChangeTutor} />
        </div>
        
        
        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Mail:</span>
            <input type="email" placeholder='Email' className='border p-2 rounded' value={inputTutor.mail} name='mail' onChange={handleChangeTutor}/>
        </div>
        
        <div className='flex flex-col gap-2'>
            <span className='text-slate-400 '>Obra Social:</span>
            <input type="text" placeholder='Obra Social' className='border p-2 rounded' value={inputTutor.medicalSecurity} name='medicalSecurity' onChange={handleChangeTutor}/>
        </div>
    
        

        <div className='flex flex-row w-80'>
          <Popup modal trigger={<p className='text-blue-600' >Firma aquí</p>} closeOnDocumentClick={false}>
          {close => (
          <>
            <div className='flex flex-row items-center justify-between'>
              <button onClick={limpiar} className='p-2 rounded-xl bg-blue-600 text-white' >Limpiar</button>
              <button onClick={close} className='text-white py-2 px-4 rounded-xl bg-red-700' >X</button>
            </div>
            <SignaturePad
            ref={signatureCanva}        
            canvasProps={{
                className: 'signatureCanvas'
            }} />
            <div className='flex items-center justify-center'>
              <button onClick={guardar} className='border p-2 rounded-xl bg-background_home text-white w-full'>Guardar</button>
            </div>
          </>
          )}     
          </Popup>
          {imageURL ? (
             <img 
                src={imageURL} 
                alt="mi firma"
                style={{
                  display: 'block',
                  margin: '0 auto',
                  width: '150px'
                }}
              />) 
              
              : null}   
                       {errors.firma && (
  <p className='text-[15px] pl-10 text-red-500'>{errors.firma}</p>)}
          </div>
 
        <button disabled={Object.keys(errors).length > 0} className={Object.keys(errors).length > 0 ? 'border p-2 w-full mt-8 rounded bg-gray-300 cursor-not-allowed text-white' : 'bg-background_home p-2 rounded text-white font-bold'}>
          ENVIAR</button>
      </form>
    </div>
  );
};

export default DeclaracionJurada;
